import React from 'react';

const Loader = () => {
    return (
        <svg width={22} height={22} viewBox="0 0 22 22">
            <defs>
                <style>
                    {
                        '.prefix__a{fill:none;stroke:#0d1fa1;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}'
                    }
                </style>
            </defs>
            <path
                className="prefix__a"
                d="M11 1v4M11 17v4M3.93 3.93l2.83 2.83M15.24 15.24l2.83 2.83M1 11h4M17 11h4M3.93 18.07l2.83-2.83M15.24 6.76l2.83-2.83"
            />
        </svg>
    );
};

export default Loader;
